// eslint-disable-next-line max-classes-per-file
const makeErrorEnum = (baseName, errorNames) => {
  class BaseError extends Error {
    constructor(message) {
      super(message);
      this.name = `${baseName}::Error`;
    }
  }

  errorNames.forEach(error => {
    BaseError[error] = class extends BaseError {
      constructor(message) {
        super(message);
        this.name = `${baseName}::${error}`;
      }
    };
  });

  return BaseError;
};

const TrelloApiError = makeErrorEnum('TrelloApi', [
  'BadRequest',
  'Conflict',
  'Forbidden',
  'InvalidResponse',
  'NotFound',
  'RateLimited',
  'Timeout',
  'Unauthorized',
  'Unknown',
]);

let codeMap;
const errorForStatus = function(status, message) {
  if (!codeMap) {
    codeMap = {
      400: TrelloApiError.BadRequest,
      401: TrelloApiError.Unauthorized,
      403: TrelloApiError.Forbidden,
      404: TrelloApiError.NotFound,
      409: TrelloApiError.Conflict,
      429: TrelloApiError.RateLimited,
    };
  }
  return new (codeMap[status] || TrelloApiError.Unknown)(message);
};

const RegistrationError = makeErrorEnum('Registration', [
  'NoNewUsers',
  'NotConfirmed',
  'NoEnterpriseBeta',
  'Unknown',
]);

const registrationErrorAlert = {
  display: 'error',
  duration: 10,
  message: 'Unable to complete setup. Please refresh the page and try again.',
};

module.exports = {
  TrelloApiError,
  RegistrationError,
  errorForStatus,
  registrationErrorAlert,
};
